import React, { useRef, useState } from "react";
import styled from "styled-components";

import WhiteTrashIcon from '../../../Image/WhiteTrashIcon.png';

export default function FlowPlanInputBox(props) {
  const { 
    isEdit, 
    value, 
    setValue, 
    division,
    uploadFlowPlan,
    deleteFlowPlan
  } = props;
  
  const HiddenFileInput = useRef(null);
  const MainCanvasRef = useRef();

  const handleClick = e => {
    if (!isEdit) return;

    HiddenFileInput.current.click();
  };

  const handleChange = e => {
    var pathpoint = e.target.value.lastIndexOf('.');
    var filepoint = e.target.value.substring(pathpoint + 1, e.target.length);
    var filetype = filepoint.toLowerCase();
    const file = e.target.files[0];

    if (!file) return;

    if (filetype === 'jpg' || filetype === 'png' || filetype === 'jpeg') {

      const reader = new FileReader();
      
      reader.onloadend = () => {
        // setValue(reader.result); // base64 문자열 저장
        uploadFlowPlan(reader.result);
      };
      
      reader.readAsDataURL(file); // base64로 변환

      // // 정상적인 이미지 확장자 파일인 경우
      // const reader = new FileReader();
      // // setImgLocalPath(e.target.value);
      // var tmp = e.target.value.split('\\');

      // setMainImgLocalPath(tmp[tmp.length - 1]);

      // reader.onloadend = () => {
      //   const base64 = reader.result;
      //   const naturalImage = new Image();

      //   naturalImage.src = reader.result.toString();

      //   naturalImage.onload = function (e) {

      //     let naturalWidth = e.target.naturalWidth;
      //     let naturalHeight = e.target.naturalHeight;

      //     let resizeWidth = 1080;
      //     let resizeHeight = 1080;

      //     const image = new Image();
      //     const canvas = MainCanvasRef.current;
      //     const ctx = canvas?.getContext('2d');

      //     if (ctx) {

      //       canvas.width = resizeWidth;
      //       canvas.height = resizeHeight;

      //       image.src = base64.toString();

      //       // 사진 크기 조정후 Canvas에 그리기 //
      //       image.onload = function () {
      //         ctx.clearRect(0, 0, canvas.width, canvas.height);
      //         ctx.drawImage(image, 0, 0, resizeWidth, resizeHeight);
      //       }

      //       // 크기 조절된 사진 데이터 정리하기 //
      //       canvas.toBlob(function (blob) {
      //         const reader = new FileReader();
      //         // Canvas에 다 그려졌을때 Event //
      //         reader.onload = function (e) {
      //           // setPicture(canvas.toDataURL())
      //           // console.log(canvas.toDataURL());
      //           setMainPicture(canvas.toDataURL());
      //         }
      //         reader.readAsDataURL(blob);
      //       })
      //     }
      //     else {
      //       alert('사용할 수 없는 파일입니다');
      //       console.log("Could not get context");
      //     }
      //   }
      // };
      // if (e.target.files[0]) {
      //   reader.readAsDataURL(e.target.files[0]);
      // }
    }
    else {
      alert('.jpeg .jpg .png 파일만 가능합니다!');
    }
  };

  return (
    <TopLevelWrapper>
      <ColumnBox>
        <Text fontFamily='NotoSansKR-Black' fontSize={14} color='#2F2F32' cursor='default'>플로우 플랜</Text>
      </ColumnBox>
      <ViewBox>
        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' cursor='default'>{division + ' 플로우 플랜을 업로드 해주세요'}</Text>

        {/* <canvas ref={MainCanvasRef} style={{ display: 'none' }} /> */}
        <input
          type="file"
          ref={HiddenFileInput}
          onChange={handleChange}
          style={{ display: 'none' }} />
        <ImageWrapper>
        {
          value === '' &&
          <AddButton onClick={handleClick} border={isEdit ? '2px dashed #909090' : '2px solid #909090'} cursor={isEdit ? 'pointer' : 'default'}>
            <PlusWrapper>
              <PlusStick width={34} height={4}/>
              <PlusStick width={4} height={34}/>
            </PlusWrapper>
          </AddButton>
        }
        {
          value !== '' &&
          <FlowPlan>
            {
              isEdit &&
              <DeleteImageWrapper>
                <DeleteButton onClick={deleteFlowPlan}>
                  <TrashImageWrapper>
                    <Image src={WhiteTrashIcon}/>
                  </TrashImageWrapper>
                </DeleteButton>
              </DeleteImageWrapper>
            }
            <Image src={value} />
          </FlowPlan>
        }
        </ImageWrapper>
      </ViewBox>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const ColumnBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 5px 10px;
  
  border-radius: 5px 5px 0px 0px;
  background-color: #6DD49E;
`;

const ViewBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  padding: 15px 15px 20px 15px;

  width: calc(100% - 30px);

  gap: 10px;

  border-radius: 0px 10px 10px 10px;
  background-color: #17171B;
`;

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 12px;
`;

const AddButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: calc(30.76% - 4px);
  height: 223px;

  border: ${props => props.border};
  border-radius: 5px;
  background-color: #2F2F32;

  :hover {
    cursor: ${props => props.cursor};
  }
`;

const FlowPlan = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 30.76%;
  height: 227px;

  border-radius: 5px;
  background-color: #2F2F32;

  overflow: hidden;
`;

const DeleteImageWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  padding: 10px 10px;

  width: calc(100% - 20px);
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 32px;
  height: 32px;

  border: 1px solid #EC6060;
  border-radius: 10px;
  background-color: #FF3131;

  :hover {
    cursor: pointer;
    background-color: #FF9898;
  }

  transition: all 0.3s ease-in-out;
`;

const TrashImageWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 14px;
  height: 14px;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
`;

const PlusWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 32px;
  height: 32px;
`;

const PlusStick = styled.div`
  position: absolute;

  width: ${props => props.width}px;
  height: ${props => props.height}px;

  border-radius: 4px;
  background-color: #969696;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  
  :hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;